"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _pick = _interopRequireDefault(require("recompose/utils/pick"));

var _toPairs = _interopRequireDefault(require("ramda/src/toPairs"));

var _recompose = require("recompose");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var withDerivedProps = function withDerivedProps(keys, derivationObjOrFn) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$passAllProps = _ref.passAllProps,
      passAllProps = _ref$passAllProps === void 0 ? false : _ref$passAllProps;

  var deriveProps = function deriveProps(props) {
    var pickedNextProps = passAllProps ? props : (0, _pick["default"])(props, keys);
    return typeof derivationObjOrFn === 'function' ? derivationObjOrFn(pickedNextProps) : (0, _toPairs["default"])(derivationObjOrFn).reduce(function (computedProps, _ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
          derivedPropName = _ref3[0],
          deriveFn = _ref3[1];

      return _objectSpread({}, computedProps, _defineProperty({}, derivedPropName, deriveFn(_objectSpread({}, pickedNextProps, {}, computedProps))));
    }, {});
  };

  return (0, _recompose.compose)((0, _recompose.withPropsOnChange)(keys, deriveProps), _recompose.pure);
};

var _default = withDerivedProps;
exports["default"] = _default;